module.exports = __webpack_public_path__ + "../resources/img/ic_re_no1_p2_line_wh.63a33ea4.svg";